let BASE_URL = "https://qradmin.spaider.se/api/";
//BASE_URL = "http://localhost:7401/api/";


let getAuth = () => null; // Default if not set

let clearAuth = () => null

export function setAuthGetter(fn) {
    getAuth = fn;
}

export function setAuthClear(fn){
    clearAuth = fn;
}

async function apiCall(endpoint, body = {}) {
    const auth = getAuth();
    if (!auth && endpoint !== "auth/login") return { ok: false };

    const fullBody = { ...body, ...auth }; // ✅ FIX: call getAuth()
    const fullUrl = BASE_URL + endpoint

    //console.log(fullBody)
    //console.log(fullUrl)
    try {
        const response = await fetch(BASE_URL + endpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(fullBody),
        });

        const data = await response.json();

        if (!response.ok) {
            if(data.code === 'INVALID_TOKEN'){
                clearAuth()
            }
            // backend sets ok: false on error, but this ensures we catch HTTP-level issues too
            throw data;
        }
        return data;
    } catch (err) {
        return {
            ok: false,
            code: err.code || "NETWORK_ERROR",
            error: err.error || "An unexpected error occurred",
        };
    }
}

export async function loginRequest(email, password) {
    return await apiCall('auth/login', {email, password}); // return the whole object, e.g., { ok: false, error: "Incorrect ..." }
}

export async function fetchUsers(){
    return await apiCall("users")
}

export async function fetchProfile(){
    return await apiCall("profile")
}

export async function removeUser(user) {
    return await apiCall('users-delete', {user});
}

export async function updateUser(user){
    return await apiCall('users-update', {user})
}

export async function createNewPassword(user){
    return await apiCall('users-new-pass',{user})
}

export async function updatePassword(newPassword, oldPassword){
    return await apiCall('new-password', {newPassword, oldPassword})
}

export async function createUser(user){
    return await apiCall('users-create', {user})
}

export async function fetchRoles(){
    return await apiCall("roles")
}

export async function availableLocations(token){
    return await apiCall('auth/locations', {token})
}

export async function getMenus(){
    return await apiCall('menus')
}

export async function getMenuAddons(gid){
    return await apiCall('menu-addons', {gid})
}

export async function getMenuItems(gid){
    return await apiCall('menu-items', {gid});
}

export async function getMenuDetails(gid){
    return await apiCall('menu-details', {gid})
}

export async function getMenuHours(gid){
    return await apiCall('menu-hours', {gid})
}

export async function saveMenuHours(gid, data){
    return await apiCall('menu-hours-upd', {gid, data})
}

export async function getMenuZones(gid){
    return await apiCall('menu-zones', {gid})
}

export async function addIngredient(igo){
    return await apiCall('ingridients-add', {igo});
}

export async function updateIngredient(igo){
    return await apiCall('ingridient-update', {igo})
}

export async function removeIngredient(igo){
    return await apiCall('ingridient-remove', {igo})
}

export async function getOrders(date, paid, query){
    return await apiCall('orders', {date, paid, query})
}

export async function getOrderItems(orderId){
    return await apiCall('order-items', {orderId})
}

export async function updateMenu(id, menu){
    return await apiCall('update-menu', {id, menu})
}

export async function updateItem(plu, item){
    return await apiCall('update-item', {item, plu})
}

export async function showCache(){
    return await apiCall('cache-show')
}

export async function flushCache(){
    return await apiCall('cache-flush')
}

export async function removeCache(menuId){
    return await apiCall('cache-remove', {menuId})
}

export async function emptyCache(){
    return await apiCall('cache-empty')
}

export async function updateCache(menuId){
    return await apiCall('cache-refresh', {menuId})
}

export async function cfgPartial(fields){
    return await apiCall('cfg-partial', {fields})
}

export async function cfgUpdate(update){
    return await apiCall('cfg-update', {update})
}

export async function cfgAdd(add){
    return await apiCall('cfg-add', {add})
}

export async function fetchVouchers(){
    return await apiCall('vouchers')
}

export async function updateVoucher(voucher){
    return await apiCall('voucher-update', {voucher})
}

export async function removeVoucher(id){
    return await apiCall('voucher-remove', {id})
}

export async function createVoucher(voucher){
    return await apiCall('voucher-add', {voucher})
}

export async function checkRights(path){
    return await apiCall('auth/page/',{path})
}

export async function fetchPermissions(){
    return await apiCall('auth/permissions/', {})
}

export async function fetchZones(){
    return await apiCall('zones')
}

export async function updateZone(zone){
    return await apiCall('zone-update',{zone})
}

export async function createZone(zone){
    return await apiCall('zone-add', {zone})
}

export async function removeZone(id){
    return await apiCall('zone-remove', {id})
}

export async function fetchIngredientSettings(){
    return await apiCall('settings-ingridients')
}

export async function saveMenuAddons(addon){
    return await apiCall('menu-addon-save', {addon})
}

export async function fetchOrderReciept(order){
    return await apiCall('gen-link', {order})
}

export async function testLogin(){
    return await apiCall('login-test')
}

export async function fetchAppearance(){
    return await apiCall('appearance')
}

export async function saveAppearance(data){
    return await apiCall('appearance-save', {data})
}
